@if (Vendor) {
  <div class="container-fluid d-flex flex-column h-100">
    <div class="row">
      <div class="col">
        <h2>QuickSourceBids - {{ Vendor.legalName }}</h2>
      </div>
    </div>
    <div class="row flex-grow-1 mb-2">
      <div class="col">
        <app-proposal-request-vendors-grid
          [gridName]="'ClientVendorProposalRequestVendors'"
          [suppliedQueryData]="suppliedGridQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          (rowClick)="action({ action: 'view', rowData: $event.data })"
          (actionEvent)="action($event)"
        ></app-proposal-request-vendors-grid>
      </div>
    </div>
  </div>
}
